export default "__VITE_ASSET__Duo1Ax6r__"